import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessComparisonByObjectId } from '@api/data-security';

export const getCoreDataSecurityAccessComparisonByObjectIdSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessComparisonByObjectId',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessComparisonByObjectId,
	retainDataOnRequest: true
});
